import { useEffect, useState } from 'react';

/**
 * useStandalone - React hook to detect if the app is running in standalone mode (PWA)
 */
export function useStandalone(): boolean {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // For iOS
    const isIOSStandalone = window.navigator.standalone === true;
    // For other browsers (Chrome, Edge, etc.)
    const isDisplayStandalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
    setIsStandalone(isIOSStandalone || isDisplayStandalone);
  }, []);

  return isStandalone;
}
